import { render, staticRenderFns } from "./MdtFileSingle.vue?vue&type=template&id=5d9b256b&scoped=true"
import script from "./MdtFileSingle.vue?vue&type=script&lang=js"
export * from "./MdtFileSingle.vue?vue&type=script&lang=js"
import style0 from "./MdtFileSingle.vue?vue&type=style&index=0&id=5d9b256b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d9b256b",
  null
  
)

export default component.exports